// extracted by mini-css-extract-plugin
module.exports = {"input":"PersonalDataSection_input__4XiZL"};